import React from 'react';
import { Button } from '../ui/button';
import { Sparkles, Search, ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../ui/utils';

interface HeroSectionProps {
  userName?: string;
  className?: string;
}

export function HeroSection({ userName, className }: HeroSectionProps) {
  const navigate = useNavigate();

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className={cn(
      'col-span-1 md:col-span-8 lg:col-span-12',
      'rounded-2xl bg-gradient-to-br from-sand to-white p-8 shadow-sm',
      className
    )}>
      <div className="mb-6">
        <h1 className="mb-2 text-3xl font-bold text-dusk">
          👋 {getGreeting()}{userName ? `, ${userName}` : ''}!
        </h1>
        <p className="text-lg text-supporting">
          Ready to plan this week's meals?
        </p>
      </div>

      <div className="flex flex-wrap gap-3">
        <Button
          size="lg"
          className="gap-2 bg-coral hover:bg-coral/90"
          onClick={() => navigate('/plans')}
        >
          <Sparkles className="h-5 w-5" />
          Generate Meal Plan
        </Button>

        <Button
          size="lg"
          variant="outline"
          className="gap-2"
          onClick={() => navigate('/discover')}
        >
          <Search className="h-5 w-5" />
          Discover Recipes
        </Button>

        <Button
          size="lg"
          variant="outline"
          className="gap-2"
          onClick={() => navigate('/shopping-list')}
        >
          <ShoppingCart className="h-5 w-5" />
          Shopping List
        </Button>
      </div>
    </div>
  );
}
